import { cn } from "@/lib/utils";

export interface ListItemIconProps extends React.HTMLAttributes<HTMLDivElement> {
  mode?: "compact" | "expanded";
}

export const ListItemIcon: React.FC<ListItemIconProps> = ({ className, mode, ...props }) => {
  return (
    <div
      className={cn(
        "item-center flex w-4.5 justify-center leading-1 text-current *:h-auto *:w-full",
      )}
    >
      {props.children}
    </div>
  );
};
